import script from "./AddPlanForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPlanForm.vue?vue&type=script&setup=true&lang=js"

import "./AddPlanForm.vue?vue&type=style&index=0&id=9682ed28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9682ed28"]])

export default __exports__